import { render, staticRenderFns } from "./FormattedDate.vue?vue&type=template&id=2aa63fd5&scoped=true"
import script from "./FormattedDate.vue?vue&type=script&lang=js"
export * from "./FormattedDate.vue?vue&type=script&lang=js"
import style0 from "./FormattedDate.vue?vue&type=style&index=0&id=2aa63fd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa63fd5",
  null
  
)

export default component.exports